import { AnalyticsEvents } from "@repo/analytics";
import { analyticsManager } from "./setupAnalytics";
import type { ProfilesData } from "../store/useAuthStore";

function getDefaultProfileUamId(
  profilesData: ProfilesData | null,
): string | null {
  const profiles = profilesData?.unified_account_details?.profiles;
  if (!profiles?.length) {
    return null;
  }
  const profile = profiles.find((p) => p.is_default_profile) ?? profiles[0];
  if (profile?.uam_id == null) {
    return null;
  }
  return String(profile.uam_id);
}

function traitsFromProfiles(
  profilesData: ProfilesData | null,
): Record<string, string> {
  const profiles = profilesData?.unified_account_details?.profiles;
  const defaultProfile =
    profiles?.find((p) => p.is_default_profile) ?? profiles?.[0];
  const uad = profilesData?.unified_account_details?.user_account_details;
  const traits: Record<string, string> = {};
  if (defaultProfile?.vertical_id != null) {
    traits.vertical_id = String(defaultProfile.vertical_id);
  }
  if (uad?.grade?.gradeId != null) {
    traits.grade_id = String(uad.grade.gradeId);
  }
  if (defaultProfile?.tenant_id != null) {
    traits.tenant_id = String(defaultProfile.tenant_id);
  }
  return traits;
}

/** Call after profiles are available and when establishing an authenticated session. */
export function syncAuthIdentityToAnalytics(
  profilesData: ProfilesData | null,
): void {
  const uamId = getDefaultProfileUamId(profilesData);
  if (!uamId) {
    return;
  }
  const traits = traitsFromProfiles(profilesData);
  analyticsManager.identify(uamId, traits);
}

export function trackAuthLoginSuccess(
  loginMethod: "phone_otp" | "username_password" | "admission_id",
  extra?: Record<string, unknown>,
): void {
  analyticsManager.track(AnalyticsEvents.LOGIN_SUCCESS, 1, {
    login_method: loginMethod,
    ...extra,
  });
}

export function clearAuthAnalyticsIdentity(): void {
  analyticsManager.resetUser();
}
